import type { ClaudiStickerId } from '../../domain';
import claudiAllHeroesImg from '../screens/components/atomic/icons/stickers/claudi_all_heroes.png';
import claudiAlmostLateImg from '../screens/components/atomic/icons/stickers/claudi_almost_late.png';
import claudiBoostPerfectImg from '../screens/components/atomic/icons/stickers/claudi_boost_perfect.png';
import claudiBumpyImg from '../screens/components/atomic/icons/stickers/claudi_bumpy.png';
import claudiFirstSuccessImg from '../screens/components/atomic/icons/stickers/claudi_first_success.png';
import claudiHeartbreakerImg from '../screens/components/atomic/icons/stickers/claudi_heartbreaker.png';
import claudiNimbleImg from '../screens/components/atomic/icons/stickers/claudi_nimble.png';
import claudiNoBoostImg from '../screens/components/atomic/icons/stickers/claudi_no_boost.png';
import claudiSecondChanceImg from '../screens/components/atomic/icons/stickers/claudi_second_chance.png';
import claudiSweetDietImg from '../screens/components/atomic/icons/stickers/claudi_sweet_diet.png';
import claudiSweetRideImg from '../screens/components/atomic/icons/stickers/claudi_sweet_ride.png';
import claudiTidyImg from '../screens/components/atomic/icons/stickers/claudi_tidy.png';
import claudiWorseReplayImg from '../screens/components/atomic/icons/stickers/claudi_worse_replay.png';
import claudiAllHeroesLockedImg from '../screens/components/atomic/icons/stickers/locked_stickers/claudi_all_heroes.png';
import claudiAlmostLateLockedImg from '../screens/components/atomic/icons/stickers/locked_stickers/claudi_almost_late.png';
import claudiBoostPerfectLockedImg from '../screens/components/atomic/icons/stickers/locked_stickers/claudi_boost_perfect.png';
import claudiBumpyLockedImg from '../screens/components/atomic/icons/stickers/locked_stickers/claudi_bumpy.png';
import claudiFirstSuccessLockedImg from '../screens/components/atomic/icons/stickers/locked_stickers/claudi_first_success.png';
import claudiHeartbreakerLockedImg from '../screens/components/atomic/icons/stickers/locked_stickers/claudi_heartbreaker.png';
import claudiNimbleLockedImg from '../screens/components/atomic/icons/stickers/locked_stickers/claudi_nimble.png';
import claudiNoBoostLockedImg from '../screens/components/atomic/icons/stickers/locked_stickers/claudi_no_boost.png';
import claudiSecondChanceLockedImg from '../screens/components/atomic/icons/stickers/locked_stickers/claudi_second_chance.png';
import claudiSweetDietLockedImg from '../screens/components/atomic/icons/stickers/locked_stickers/claudi_sweet_diet.png';
import claudiSweetRideLockedImg from '../screens/components/atomic/icons/stickers/locked_stickers/claudi_sweet_ride.png';
import claudiTidyLockedImg from '../screens/components/atomic/icons/stickers/locked_stickers/claudi_tidy.png';
import claudiWorseReplayLockedImg from '../screens/components/atomic/icons/stickers/locked_stickers/claudi_worse_replay.png';

export const CLAUDI_STICKER_ICONS: Record<ClaudiStickerId, string> = {
  claudi_first_success: claudiFirstSuccessImg,
  claudi_sweet_ride: claudiSweetRideImg,
  claudi_nimble: claudiNimbleImg,
  claudi_boost_perfect: claudiBoostPerfectImg,
  claudi_tidy: claudiTidyImg,
  claudi_second_chance: claudiSecondChanceImg,
  claudi_all_heroes: claudiAllHeroesImg,
  claudi_almost_late: claudiAlmostLateImg,
  claudi_sweet_diet: claudiSweetDietImg,
  claudi_heartbreaker: claudiHeartbreakerImg,
  claudi_bumpy: claudiBumpyImg,
  claudi_worse_replay: claudiWorseReplayImg,
  claudi_no_boost: claudiNoBoostImg,
};

export const CLAUDI_STICKER_LOCKED_ICONS: Record<ClaudiStickerId, string> = {
  claudi_first_success: claudiFirstSuccessLockedImg,
  claudi_sweet_ride: claudiSweetRideLockedImg,
  claudi_nimble: claudiNimbleLockedImg,
  claudi_boost_perfect: claudiBoostPerfectLockedImg,
  claudi_tidy: claudiTidyLockedImg,
  claudi_second_chance: claudiSecondChanceLockedImg,
  claudi_all_heroes: claudiAllHeroesLockedImg,
  claudi_almost_late: claudiAlmostLateLockedImg,
  claudi_sweet_diet: claudiSweetDietLockedImg,
  claudi_heartbreaker: claudiHeartbreakerLockedImg,
  claudi_bumpy: claudiBumpyLockedImg,
  claudi_worse_replay: claudiWorseReplayLockedImg,
  claudi_no_boost: claudiNoBoostLockedImg,
};

export function claudiStickerIconSrc(id: ClaudiStickerId): string {
  return CLAUDI_STICKER_ICONS[id];
}

export function claudiStickerLockedIconSrc(id: ClaudiStickerId): string {
  return CLAUDI_STICKER_LOCKED_ICONS[id];
}
